export enum KEYBOARD_KEY {
  ENTER = "Enter",
  BACKSPACE = "Backspace",
  ESCAPE = "Escape",
  SPACE = " "
}